export default "__VITE_ASSET__DMAWXIYo__"